const formatDigit = value => {
  const safeValue = Number.isFinite(Number(value)) ? Number(value) : 0
  const leftDigit = safeValue >= 10 ? safeValue.toString()[0] : '0'
  const rightDigit =
    safeValue >= 10 ? safeValue.toString()[1] : safeValue.toString()

  return `${leftDigit}${rightDigit}`
}

export { formatDigit }
